import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import React from 'react';

const buttonVariants = cva(
	'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-2xl text-sm font-semibold ring-offset-background transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:pointer-events-none disabled:opacity-50 min-h-11',
	{
		variants: {
			variant: {
				default: 'bg-primary text-primary-foreground shadow-glow hover:bg-primary/95',
				destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
				outline: 'border border-border/80 bg-background/70 text-foreground hover:bg-accent hover:text-accent-foreground',
				secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/85',
				success: 'bg-emerald-600 text-white hover:bg-emerald-700',
				ghost: 'text-foreground hover:bg-accent hover:text-accent-foreground',
				link: 'min-h-0 rounded-none p-0 text-primary underline-offset-4 hover:underline',
			},
			size: {
				default: 'px-4 py-2.5',
				sm: 'min-h-10 rounded-xl px-3.5',
				lg: 'min-h-12 rounded-2xl px-6 text-base',
				icon: 'h-11 w-11 rounded-2xl p-0',
			},
		},
		defaultVariants: {
			variant: 'default',
			size: 'default',
		},
	}
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
	const Comp = asChild ? Slot : 'button';
	return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />;
});

Button.displayName = 'Button';

export { Button, buttonVariants };